import dayjs from "dayjs";

export function getMonthsShortNames(): string[] {
  return Array.from({ length: 12 }, (_, i) =>
    new Date(0, i).toLocaleString("default", { month: "short" })
  );
}

export function getMonthsLongNames(): string[] {
  return Array.from({ length: 12 }, (_, i) =>
    new Date(0, i).toLocaleString("default", { month: "long" })
  );
}

export function getMonthIndex(monthName: string): number {
  const monthNames: string[] = getMonthsLongNames();
  const index = monthNames.indexOf(monthName);

  if (index === -1) throw new Error(`Invalid month name: ${monthName}`);
  return index;
}

export function getFirstDayOfMonth(year: number, month: number): Date {
  return new Date(year, month, 1);
}

export function getLastDayOfMonth(year: number, month: number): Date {
  return new Date(year, month + 1, 0);
}

export function formatBackendDate(date: Date): string {
  return dayjs(date).format("DD/MM/YYYY").toString();
}
